import { Button, Modal } from '@keboola/design';

const SUPPORT_EMAIL = 'support@keboola.com';

/**
 * The public footer's "Contact" entry: a dialog holding the support address.
 *
 * - A dialog, not a `/contact` page — the parity contract records contact as modal-only.
 * - The address is a `mailto:` link, not text. It is the one thing the dialog exists to hand over, so
 *   a reader who cannot click it has been given a worse version of a footer link.
 * - Closed by `Modal.Content`'s own control, with no second one in a footer: two buttons named "Close"
 *   in one dialog is an ambiguous accessible name. Same shape as the rejection-reason dialog.
 */
export function ContactModal() {
  return (
    <Modal>
      <Modal.Trigger asChild>
        {/* `variant="inline"`: this sits in a row of footer links, and a filled control beside them
            would read as the page's primary action. */}
        <Button variant="inline">Contact</Button>
      </Modal.Trigger>
      <Modal.Content size="small">
        <Modal.Header description="Questions about publishing a component, vendor access, or the Developer Portal API.">
          Contact us
        </Modal.Header>
        <Modal.Body>
          <p className="tw:m-0">
            Write to{' '}
            {/* Underlined rather than colour-only (WCAG 1.4.1), matching the other inline links. */}
            <a className="tw:text-primary tw:underline" href={`mailto:${SUPPORT_EMAIL}`}>
              {SUPPORT_EMAIL}
            </a>{' '}
            and the platform team will pick it up.
          </p>
        </Modal.Body>
      </Modal.Content>
    </Modal>
  );
}
